import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { User } from '../../types';

interface UserStore {
    // State
    user: User | null;

    // Actions
    setUser: (user: User | null) => void;
    updateUser: (updates: Partial<User>) => void;
    clearUser: () => void;
}

const initialState = {
    user: null,
};

export const useUserStore = create<UserStore>()(
    persist(
        (set) => ({
            ...initialState,

            setUser: (user) => set({ user }),

            updateUser: (updates) => set((state) => ({
                user: state.user ? { ...state.user, ...updates } : null,
            })),

            clearUser: () => set({ user: null }),
        }),
        {
            name: 'user-storage',
            partialize: (state) => ({
                user: state.user,
            }),
        }
    )
);
